import React from "react";
import { Paper, Table, TableBody, TableCell } from "@mui/material";
import { TableContainer, TableHead, TableRow } from "@mui/material";

function GatePass({ items, onChange }) {
  return (
    <TableContainer sx={{ mt: 1 }} component={Paper}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>Selected</TableCell>
            <TableCell sx={{ lineHeight: "1rem" }}>Item Name</TableCell>
            <TableCell sx={{ lineHeight: "1rem" }}>Sale Quantity</TableCell>
            <TableCell sx={{ lineHeight: "1rem" }}>Sale Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items &&
            items.map((item, i) => {
              return (
                <TableRow key={i}>
                  <TableCell component="th" scope="row">
                    <input
                      type="checkbox"
                      defaultChecked=""
                      onChange={() => onChange(item)}
                    />
                  </TableCell>
                  <TableCell component="th" scope="row" className="fs-8">
                    {item.itemName}
                  </TableCell>
                  <TableCell component="th" scope="row" className="fs-8">
                    {parseInt(item.saleQuantity)}
                  </TableCell>
                  <TableCell component="th" scope="row" className="fs-8">
                    {parseInt(item.saleAmount)}
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default GatePass;
